import React, { useState } from 'react';

const ICONS = [
  'sunrise', 'sunset', 'sun', 'sunset-fill', 'moon-stars', 'moon', 'stars', 'cloud-sun',
  'clouds', 'cloud-rain', 'droplet', 'flower1', 'snow', 'wind', 'lightning-charge',
  'heart', 'heart-pulse', 'heart-half', 'emoji-heart-eyes', 'person-heart', 'hand-thumbs-up',
  'people', 'person', 'people-fill', 'person-arms-up', 'people-heart', 'heartbreak',
  'book', 'book-half', 'journal-text', 'bookmark', 'bookmark-star', 'headphones',
  'music-note', 'music-note-beamed', 'play-circle', 'soundwave',
  'egg-fried', 'cup-hot', 'cup-straw', 'cup', 'water', 'apple', 'basket', 'basket-fill',
  'backpack', 'car-front', 'airplane', 'airplane-engines', 'signpost', 'compass',
  'map', 'geo-alt', 'buildings', 'building',
  'hand-index-thumb', 'hand-heart', 'bandaid', 'heart-pulse-fill', 'activity',
  'shield', 'shield-check', 'sparkles', 'gem', 'flower2', 'leaf', 'tree',
  'lightbulb', 'bulb', 'quote', 'chat-quote', 'chat-heart', 'envelope-heart',
  'pray', 'hurricane', 'rainbow', 'stars-fill', 'award', 'trophy', 'star', 'star-fill',
  'arrow-up', 'pause', 'play', 'stopwatch', 'alarm', 'bell', 'clock', 'clock-fill',
];

const IconPicker = ({ value, onChange }) => {
  const [search, setSearch] = useState('');
  const [showAll, setShowAll] = useState(false);
  const query = search.trim().toLowerCase();
  const filtered = query ? ICONS.filter((icon) => icon.includes(query)) : ICONS;
  const visible = showAll ? filtered : filtered.slice(0, 24);

  const renderIcon = (icon) => (
    <button
      key={icon}
      type="button"
      className={`btn btn-sm icon-option ${value === icon ? 'icon-option-selected' : ''}`}
      onClick={() => { onChange(icon); setShowAll(false); }}
      title={icon}
    >
      <i className={`bi bi-${icon}`}></i>
    </button>
  );

  return (
    <div className="icon-picker">
      {value && (
        <div className="d-flex align-items-center gap-2 mb-2">
          <span className="selected-icon-preview"><i className={`bi bi-${value}`}></i></span>
          <span className="text-muted">Selected: <strong>{value}</strong></span>
        </div>
      )}
      <input
        type="text"
        className="form-control form-control-sm mb-2"
        placeholder="Search icons..."
        value={search}
        onChange={(e) => { setSearch(e.target.value); setShowAll(true); }}
      />
      <div className="icon-grid">
        {filtered.length === 0 ? (
          <span className="text-muted small">No icons match "{search}"</span>
        ) : (
          visible.map(renderIcon)
        )}
      </div>
      {!query && filtered.length > 24 && (
        <button type="button" className="btn btn-link btn-sm mt-1 p-0" onClick={() => setShowAll(!showAll)}>
          {showAll ? 'Show less' : `Show all (${filtered.length})`}
        </button>
      )}
    </div>
  );
};

export default IconPicker;